module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABUklEQVQ4ja3Vu0scURTH8Y/jsGInKQLighZ2VhLzP6TyAW6hvY1gY4iPfyCyicRG8F8Q32JrKQiKTdJu5+tvWCGQYu6EcRx3Fp0fHO6de875zp2Ze870jJ1/V6AapoONox7WHnCJY5ziKZ8YF8Bm8AOjBb6RYHNoYSXA/yvKzHvRxNErsLxGQ2wz5L7Y4Qa+dQHKayWMq9kdNjrA/gR/qwQ6mwL78KtD8AUOcFWy0y3UonD3eklwN6qjEWGqAliq6QifKwROxBjsMvgMt2E+gAXPjx0MxugpAfWHcTdYqi8YzsU+xZJyyjuymscHtDNrH1/JeYxxXQKsYbKDP6vfkaTIq9JJhH3cVQC7w0EkeTdfKwAuo51+9j1svgP2U/Kkz87RGnbeANvGenqRBf7FoqRrdOosqVohdinkorhjH0qqoiHp3p8wFHz3uJF06X0Fv4B/7h05wUlw4TcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alarm/now-time-icon.png
// module id = X7G4
// module chunks = 1